import script from "./EnterpriseForgotPasswordDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EnterpriseForgotPasswordDialog.vue?vue&type=script&setup=true&lang=js"

import "./EnterpriseForgotPasswordDialog.vue?vue&type=style&index=0&id=4901aed7&lang=scss&scoped=true"
import "./EnterpriseForgotPasswordDialog.vue?vue&type=style&index=1&id=4901aed7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4901aed7"]])

export default __exports__